import { SectionFilter, SectionFilterTableData } from "../store/sections/types";

export const mapSectionFiltersToFilterData = (obj: SectionFilter): SectionFilterTableData =>({
    ...obj,
    webSectionSingleSelectFlag: String(obj.webSectionSingleSelectFlag),
    webSectionSearchFlag: String(obj.webSectionSearchFlag),
});

export const mapSectionFiltersToFilterDataArray = (objArray: SectionFilter[]): SectionFilterTableData[] => {
    return objArray.map(mapSectionFiltersToFilterData);;
}